import zhCN from './json/vote.zh_CN.json';
import zhTW from './json/vote.zh_TW.json';
import en from './json/vote.en.json';
import ja from './json/vote.ja.json';
import ko from './json/vote.ko.json';
import ru from './json/vote.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
